<template>
    <div id="settings" :style="`width: ${width}%; z-index: ${Topography()}`">
        <div id="settings-closed" v-show="!open">
            <img class="btn" src="@/assets/Images/IconSettings.png" alt="Icon - Settings" title="Settings" width="30" height="30" @click="ToggleSettings()"/>
        </div>
        <div id="settings-opened" class="flex">
            <div class="flex-y-center" v-show="open">
                <Setting :setting="settings.view" @select="$emit('select', $event)"/>
                <div>
                    <img class="block btn" src="@/assets/Images/Close.png" alt="Close" title="Close" width="30" height="30" @click="ToggleSettings()"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Setting from "@/components/Settings/Setting.vue";
import { Animation } from "@/assets/JS/Animation.js";
import $ from "jquery";

export default {
    name: "Settings",
    props: { topography: Number },
    components: { Setting },
    data: () => ({
        open: false,
        width: 0,
        settings: {
            view: {
                type: "View",
                values: [
                    "Timeline",
                    "List"
                ]
            }
        }
    }),
    methods: {
        ToggleSettings: function() {
            this.open = !this.open;
            if (this.open) {
                this.width = 100;
            }
            const component = this;
            new Animation(
                $("#settings-opened"),
                "Height",
                this.open ? 70 : 0,
                250,
                0,
                function() {
                    if (!component.open) {
                        component.width = 0;
                    }
                }
            );
        },
        Topography: function() {
            return this.topography > 0 ? this.topography : 1000;
        }
    },
    emits: [ "select" ]
};
</script>